@if (value(); as badgeValue) {
  <span class="filter-badge">{{ badgeValue }}</span>
}
